import { render, staticRenderFns } from "./MortgageObjects.vue?vue&type=template&id=174491c7&scoped=true&"
import script from "./MortgageObjects.vue?vue&type=script&lang=js&"
export * from "./MortgageObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174491c7",
  null
  
)

export default component.exports